module.exports = __webpack_public_path__ + "static/media/Slider 2 2.860416dd.jpg";